import { memo, useCallback } from 'react';

import { WorkspaceAgentQuoteCard } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/WorkspaceAgentQuoteCard';
import { type WorkspaceAgentSummaryBulletQuote } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/summary/types';

export type WorkspaceAgentSummaryBulletQuoteCardProps = {
  'data-testid'?: string;
  onOpen?: (id: string) => void;
  quote: WorkspaceAgentSummaryBulletQuote;
};

/**
 * A bullet's quotation. Exists so the bullet's `onOpen` can be bound to a quote id once per card
 * rather than rebuilt on every render of the bullet.
 */
export const WorkspaceAgentSummaryBulletQuoteCard = memo(
  ({ 'data-testid': testId, onOpen, quote }: WorkspaceAgentSummaryBulletQuoteCardProps) => {
    const handleOpen = useCallback(() => onOpen?.(quote.id), [onOpen, quote.id]);

    return (
      <WorkspaceAgentQuoteCard
        attribution={quote.attribution}
        data-testid={testId}
        onOpen={onOpen ? handleOpen : undefined}
        quote={quote.quote}
      />
    );
  },
);

WorkspaceAgentSummaryBulletQuoteCard.displayName = 'WorkspaceAgentSummaryBulletQuoteCard';
